import { z } from 'zod';

export const BaseResponse = <TSchema>(schema: z.ZodSchema<TSchema>) => {
  return z.object({
    data: schema,
    error: z
      .object({
        title: z.string(),
        statusCode: z.number(),
        description: z.string(),
      })
      .optional(),
    links: z
      .object({
        self: z.object({
          method: z.union([
            z.literal('POST'),
            z.literal('PATCH'),
            z.literal('PUT'),
            z.literal('GET'),
            z.literal('DELETE'),
          ]),
          url: z.string(),
        }),
      })
      .optional(),
    meta: z.object({
      status: z.enum(['Success', 'Fail', 'Error', 'Critical']),
    }),
  });
};

export const Response = <TSchema>(schema: z.ZodSchema<TSchema>) => {
  return BaseResponse(schema);
};

export const PaginatedResponse = <TSchema>(schema: z.ZodSchema<TSchema>) => {
  return BaseResponse(z.array(schema));
};

export const PaginationSchema = <T>(schema: z.ZodType<T>) => {
  return z.object({
    total: z.number(),
    page: z.number(),
    per_page: z.number(),
    data: z.array(schema),
  });
};

export const ImageSchema = z.object({
  external_key: z.string(),
  url: z.string(),
});

export const PriceSchema = z.object({
  amount: z.number(),
  currency_code: z.string(),
  prefix: z.string().optional(),
  suffix: z.string().optional(),
});

export const DiscountSchema = z.object({
  discounted_price: PriceSchema,
  standard_price: PriceSchema,
  name: z.string(),
});
